import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    ViberShareButton,
    WhatsappShareButton,
    FacebookShareCount,
    EmailIcon,
    FacebookIcon,
    LinkedinIcon, 
    TwitterIcon, 
    ViberIcon, 
    WhatsappIcon
} from "react-share";

import { fetchPost } from '../../store/actions/blogActions';
import history from '../../store/router/history';
import Carousel from '../Global/Carousel';
import moment from 'moment';
import { createImageUrl, isObjectEmpty } from '../../helpers/commonHelpers';
import { Link } from 'react-router-dom';
import LongBlogCard from '../BlogPage/LongBlogCard';
import loader from "../../assets/animations/loader-b.svg";
import placeholder from '../../assets/images/opcinaLogo.svg';

moment.locale('bs')

class PostPage extends Component {
    componentDidMount(){
        if(!history.location.state){
            const id = history.location.pathname.replace('/post/', '');

            if (id) {
                this.props.fetchPost(id);
            }
        }
        else 
            this.props.fetchPost(history.location.state);
    }

    render() {
        const { post, relatedPosts, newestPosts, popularPosts, fetchingPost, region } = this.props;

        return (
            <div className="post-page">
                
                {fetchingPost ? <img src={loader} alt="loader" className="post-page__loading" /> :
                <React.Fragment>
                        <Helmet>
                            <meta name="description" content={post?.description} />
                            <title>
                                {region === 'FB' ? 'Općina' : 'Opština'}.ba | {post.title??'/'}
                            </title>
                            <meta name="og:image" content={post?.main_image ? createImageUrl(post?.main_image) : placeholder} />
                            <meta name="og:description" content={post?.description} />
                            <meta name="og:title" content={post?.title} />
                        </Helmet>
                        <div className="post-page__content">
                            <h1 className="post-page__title">
                                {post?.title}
                                <span className="post-page__date">

                                    {moment(post?.publishedAt).format('DD.MM.YYYY.')}
                                </span>
                            </h1>
                            <h2 className="post-page__description">
                                {post?.description}
                            </h2>
                            <h3 className="post-page__category">
                                {post?.category}
                            </h3>
                            <div className="post-page__socials">
                                <EmailShareButton subject={post?.title} body={post?.description} >
                                    <EmailIcon size={32} className="post-page__socials__icon" />
                                </EmailShareButton>
                                <FacebookShareButton url={window.location.href} quote={post?.title} hashtag={'#opcinaba #opstinaba'} >
                                    <FacebookIcon size={32} className="post-page__socials__icon" />
                                </FacebookShareButton>
                                <LinkedinShareButton url={window.location.href} title={post?.title} summary={post?.description} source={'Općina.ba'} > 
                                    <LinkedinIcon size={32} className="post-page__socials__icon" />
                                </LinkedinShareButton>
                                <TwitterShareButton url={window.location.href} title={post?.title} hashtags={['#opcinaba', '#opstinaba']} >
                                    <TwitterIcon size={32} className="post-page__socials__icon" />
                                </TwitterShareButton>
                                <ViberShareButton url={window.location.href} title={post?.title} >
                                    <ViberIcon size={32} className="post-page__socials__icon" />
                                </ViberShareButton>
                                <WhatsappShareButton url={window.location.href} title={post?.title} >
                                    <WhatsappIcon size={32} className="post-page__socials__icon" />
                                </WhatsappShareButton>
                                <FacebookShareCount url={window.location.href} />
                            </div>
                            <hr className="post-page__break" />
                            <Carousel images={[...(post.images ? post.images : [])]} imageCount={post?.images?.length} />
                            <div className="post-page__html" dangerouslySetInnerHTML={{ __html: post?.content }} />
                        </div>
                        <div className="post-page__sidebar">
                            <h1 className="post-page__sidebar__title">
                                {region ? (region === 'FB' ? 'Općina' : 'Opština') : null} i načelnik
                            </h1>
                            <div className="post-page__sidebar__links">

                                {post?.mayor && !isObjectEmpty(post?.mayor) ?
                                    <div className="post-page__mayor">
                                        <Link to={`/mayors/${post?.mayor?._id}`}>
                                            <img src={createImageUrl(post?.mayor?.main_image)} alt="mayor" className="post-page__mayor__image" />
                                            <h1 className="post-page__mayor__title">
                                                Načelnik:
                                            </h1>
                                            <h1 className="post-page__mayor__name">
                                                {post?.mayor?.firstName + ' ' + post?.mayor?.lastName}
                                            </h1>
                                        </Link>
                                    </div>
                                : null}
                                {post?.municipality && !isObjectEmpty(post?.municipality) ?
                                    <div className="post-page__mayor">
                                        <Link to={`/municipalities/${post?.municipality?._id}`}>
                                            <img src={createImageUrl(post?.municipality?.main_image)} alt="mayor" className="post-page__mayor__image" />
                                            <h1 className="post-page__mayor__title">
                                                {region ? (region === 'FB' ? 'Općina' : 'Opština') : null}
                                            </h1>
                                            <h1 className="post-page__mayor__name">
                                                {post?.municipality?.name}
                                            </h1>
                                        </Link>
                                    </div>
                                : null}


                            </div>

                            {relatedPosts?.length ?
                                <h1 className="post-page__sidebar__title">
                                    Još iz kategorije:
                        </h1> : null}

                            {relatedPosts?.length ? relatedPosts.map(relatedPost => {
                                return <LongBlogCard key={relatedPost._id} post={relatedPost} />
                            }) : null}

                            {newestPosts?.length ?
                                <h1 className="post-page__sidebar__title">
                                    Najnoviji:
                        </h1> : null}

                            {newestPosts?.length ? newestPosts.map(newestPost => {
                                return <LongBlogCard key={newestPost._id} post={newestPost} />
                            }) : null}


                            {popularPosts?.length ?
                                <h1 className="post-page__sidebar__title">
                                    Najpopularniji:
                        </h1> : null}

                            {popularPosts?.length ? popularPosts.map(popularPost => {
                                return <LongBlogCard key={popularPost._id} post={popularPost} />
                            }) : null}
                        </div>
                </React.Fragment>} 
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        post: state.blog.post,
        relatedPosts: state.blog.relatedPosts,
        newestPosts: state.blog.newestPosts,
        popularPosts: state.blog.popularPosts,
        fetchingPost: state.blog.fetchingPost,
        region: state.common.region
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchPost: (id) => { dispatch(fetchPost(id)) }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PostPage);